export const APP_ROUTES = {
  home: "/",
} as const;
